import React, { useState, useEffect } from "react";
import Header from "../../../core/header/Header";
import Footer from "../../../core/footer/Footer";
import { Link } from "react-router-dom";
import "./error.scss";
import Helmet from "../../../helmet/helmet";
import { index } from "../../../helpers/constants/routerConstants";

function Error() {
    const languageLabel = window.Weglot.getCurrentLang() ? window.Weglot.getCurrentLang() : localStorage.getItem("wglang");
    const languageName = window.Weglot.getCurrentLang() ? window.Weglot.getLanguageName(languageLabel) : "English";
    const [isParentData, setIsParentData] = useState({ language: languageName });
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="page-het hfhider">
            <Helmet title="404 - File or directory not found." addPostfixTitle={true} />
            <Header toChild={isParentData} sendToParent={setIsParentData} />
            <section className="page-section price-w-100">
                <div className="full-width-screen">
                    <div className="container-fluid">
                        <div className="content-detail">
                            <h1 className="global-title"><span>4</span><span>0</span><span>4</span></h1>
                            <h4 className="sub-title">Oops!</h4>
                            <p className="detail-text">We're sorry,<br /> We can't seem to find a page you're looking for</p>
                            <div className="back-btn">
                                <Link to={index} className="btn">Back to Home</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer toprops={isParentData} />
        </div>
    );
}
export default Error;